import { makeStyles } from '@material-ui/core/styles'


export const useStyles = makeStyles(theme => ({
  cancel: {
    color: theme.palette.danger.main
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  content: {
    padding: 0,
    display: 'flex',
    '& p': {
      margin: '4px 32px',
      display: 'flex',

      '&:first-child': {
        marginTop: 16
      },
      '&:last-child': {
        marginBottom: 16
      },

      '& > .MuiChip-root': {
        marginLeft: 8,
        textTransform: 'capitalize',
      }
    },
    '& > div': {
      width: '50%',
    },
    [theme.breakpoints.down('670')]: {
      flexDirection: 'column',
      '& > div': {
        width: 'auto',
      },
    },
  },
  infos: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: '100%',
      // background: '#eee',
      '& p': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }
  },
  paiement: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    padding: 16,
    '& > div': {
      marginBottom: 8,
      padding: '0!important'
    }
  },
  bold: {
    display: 'contents',
    fontWeight: 600,
  },
  loading: {
    opacity: .3,
  }
}))